import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Tab } from 'legacyComponents/styled/lib';

import { ClosedProjectIssueCard } from 'legacyComponents/cards/types/projectIssue';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { NoDataCard } from 'legacyComponents/cards/types/noData';

@observer
export class ClosedIssuesTab extends React.Component {
  render() {
    const { app, project, manager } = this.props;
    const issues = app.manager.closedIssuesConn.arrayApp;

    const closedIssuesCount =
      project.manager.issueTrackerAppManager?.issueTracker?.closedIssuesCount;

    if (closedIssuesCount === 0) {
      return (
        <NoDataCard
          type='closedIssues'
          manager={manager}
          owner={project.canUpdate}
        />
      );
    }
    return (
      <Tab noShadow>
        <CardSection
          title=''
          cardApp={issues}
          CardComponent={ClosedProjectIssueCard}
          noMarginTop
        />
      </Tab>
    );
  }
}

ClosedIssuesTab.propTypes = {
  app: PropTypes.object,
  manager: PropTypes.object,
  project: PropTypes.object,
};
